<template>
  <!-- 全局遮罩 -->
  <div
    v-if="visible"
    class="my-modal-mask"
    @click.self="handleClose"
    :style="{ zIndex: showIndex }"
  >
    <!-- 弹窗内容 -->
    <div class="my-modal-content" :style="{ width: customWidth }">
      <div v-if="showHeader" class="header-div">
        <div
          style="
            font-size: 18px;
            font-weight: 600;
            color: #2b2f36;
            line-height: 24px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          "
        >
          {{ title }}
        </div>
        <img
          src="https://ossfastmake.mustke.com/qrCode/tupian/1736759941513.png"
          mode=""
          @click.self="handleClose"
          style="
            width: 13px;
            height: 13px;
            position: absolute;
            right: 20px;
            cursor: pointer;
          "
        />
      </div>
      <!-- 插槽：放你自己的内容 -->
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "MyModal",
  props: {
    // 控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    // 弹窗标题
    title: {
      type: String,
      default: "",
    },
    // 自定义宽度：如 '500px' / '60%' / '800px'
    customWidth: {
      type: String,
      default: "500px",
    },
    // 点击蒙层是否关闭
    closeOnClickMask: {
      type: Boolean,
      default: true,
    },
    showIndex: {
      type: Number,
      default: 999999999,
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    handleClose() {
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style scoped>
/* 半透明背景 */
.my-modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5); /* 半透明 */
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 弹窗内容 */
.my-modal-content {
  background: #fff;
  border-radius: 10px;
  position: relative;
  max-height: 85vh;
  overflow-y: auto;
  box-sizing: border-box;
}

.header-div {
  width: 100%;
  height: 59px;
  background-color: #ffffff;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  padding: 0 14px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e7e7e7;
  position: relative;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/MyModal/MyModal.vue